import { guid } from './guid';

const clientGuid = guid();

export function getClientGuid() {
    return clientGuid;
}
